import { without } from "lodash-es";
import React from "react";
import type { ItemBinding } from "../../../../clients/graphqlTypes.js";
import { FilterChip } from "../../../commons/filters/FilterChip.js";
import { useItemBindings } from "../hooks/useItemBindings.js";

interface Props {
  label?: string;
  value: ItemBinding[] | null | undefined;
  setValue: (newValue: ItemBinding[] | null | undefined) => void;
}

export const ItemBindingChips = ({ label, value, setValue }: Props) => {
  const { itemBindingOptions, itemBindingLabels } = useItemBindings();
  const getValueLabel = React.useCallback(
    (value: ItemBinding) => itemBindingLabels[value],
    [itemBindingLabels]
  );
  return (
    <>
      {itemBindingOptions
        .filter(o => value && value.includes(o.value))
        .map(itemType => (
          <FilterChip
            key={itemType.value}
            label={label}
            onDelete={() => {
              const newValue = without(value, itemType.value);
              setValue(newValue.length > 0 ? newValue : undefined);
            }}
            value={itemType.value}
            getValueLabel={getValueLabel}
          />
        ))}
    </>
  );
};
